export const SET_VIEWED_EDUCATION_DATA = 'SET_VIEWED_EDUCATION_DATA';
export const SET_NOTIFICATION_DATA = 'SET_NOTIFICATION_DATA';
